<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card v-if="!selectedAssembly">
        <v-card-title>
          iMatch Database
          <v-spacer></v-spacer>
          <v-select 
            class="mr-3"
            width="200"
            :items="assemblyTypes"
            item-value="id"
            item-text="name"
            single-line
            hide-details
            v-model="typeFilter">
          </v-select>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Zoeken"
            clearable
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>      
        <v-data-table 
          :headers="headers"
          :items="assemblies"
          :search="search"
          :pagination.sync="pagination"
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ getAssemblyTypeNameById(props.item.type) }}</td>
            <td class="text-xs-left">{{ getStateValue(props.item.state) }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.modified) }}</td>
            <td class="text-xs-left">{{ props.item.boardSerialnumber }}</td>
            <td class="text-xs-left">{{ props.item.caseSerialnumber }}</td>
            <td class="text-xs-left">{{ props.item.bluetoothId }}</td>
            <td class="text-xs-left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessBtL ? 'green' : 'red'">check</v-icon>
                </template>
                <span>Button Left</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessBtR ? 'green' : 'red'">check</v-icon>
                </template>
                <span>Button Right</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessLed ? 'green' : 'red'">check</v-icon>
                </template>
                <span>LEDs</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessFpr ? 'green' : 'red'">check</v-icon>
                </template>
                <span>Fingerprint scanner</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessScr ? 'green' : 'red'">check</v-icon>
                </template>
                <span>Smartcard reader</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessNfc ? 'green' : 'red'">check</v-icon>
                </template>
                <span>NFC adapter</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" :color="props.item.testSuccessQA ? 'green' : 'red'">check</v-icon>
                </template>
                <span>General QA</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left" style="max-width:150px">{{ props.item.client }}</td>
            <td class="text-xs-left" style="max-width:150px">{{ props.item.orderNumber }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.shippedOut) }}</td>
            <td class="text-xs-left">
              <v-btn 
              flat 
              icon 
              color="accent"
              @click="editAssembly(props.item.id)">
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </template>          
        </v-data-table>
      </v-card>
      <assemblyForm
        v-if="selectedAssembly"
        :assembly="selectedAssembly"
        v-on:done="getData">
      </assemblyForm>      
    </v-flex>        
    <v-flex xs12 sm12 md12 lg12 xl12 v-if="!selectedAssembly">
      <v-btn @click.native="openFileDialog">
        Upload boards/cases file
        <v-icon right dark> cloud_upload</v-icon>
      </v-btn>
      {{currentBoardsCasesFile}}
      <input type="file" id="file-upload" style="display:none" @change="onFileChange">
    </v-flex>
  </v-layout>
</template>
<script>
  import assemblyForm from '../components/AssemblyForm.vue'
  export default {
    name: 'Database',
    components: { 
      assemblyForm
    },
    data() {
      return {
        search: '',
        currentBoardsCasesFile: '',
        selectedAssembly: null,
        assemblies: [],
        assemblyTypes: [],
        typeFilter: 0,
        headers: [
          { text: 'Id', value: 'id' },
          { text: 'Type', value: 'type' },
          { text: 'Status', value: 'state' },
          { text: 'Datum', value: 'modified' },
          { text: 'Board', value: 'boardSerialnumber' },
          { text: 'Behuizing', value: 'caseSerialnumber' },
          { text: 'Bluetooth', value: 'bluetoothId' },
          { text: 'Tests', value: 'testSuccessQa' },
          { text: 'Klant', value: 'client' },
          { text: 'Ordernummer', value: 'orderNumber' },
          { text: 'Uitgeleverd', value: 'shippedOut' },
          { text: '', value: 'id', sortable: false }
        ],
        pagination: {
          rowsPerPage: 25,
          descending: true,
          sortBy: "id"
        },
        states: [
          { key: 0, value: 'Nieuw' },
          { key: 1, value: 'Geassembleerd' },
          { key: 2, value: 'Getest' },
          { key: 3, value: 'Uitgeleverd' },
          { key: 4, value: 'RMA' },
          { key: 5, value: 'Vernietigd' },
        ],
      }
    },
    watch: {
      typeFilter() {
        this.getData();
      }
    },
    computed: {
      typeFilterQuery() {
        if (this.typeFilter == 0) return ''
        return '?type=' + this.typeFilter;
      }
    },
    methods: {
      openFileDialog() {
          document.getElementById('file-upload').click();
      },
      onFileChange(e) {
        var formData = new FormData()
        var self = this
        var files = e.target.files || e.dataTransfer.files    
        if(files.length > 0){
          self.currentBoardsCasesFile = files[0].name
          formData.append("file", files[0]);
        }
        this.submitStatus = 'Importing case/boards file..'
        this.$http.post('api/import/BoardCaseNumbers/', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(request => {
            if (request.status == 200) {
              this.submitStatus = 'OK'
              if (request.data.successes) this.submitStatus += ' imported ' + request.data.successes + ' bookings'
              if (request.data.errors && request.data.errors.length > 0) this.submitStatus += ' with ' + request.data.errors.length + ' errors'
              this.currentBoardsCasesFile = null
              this.getData()
            } else {
              this.submitStatus = 'ERROR'
            }
          })
          .catch(() => { 
            console.log('post error!') /* eslint-disable-line no-console */
            this.submitStatus = 'ERROR'
          })   
      },
      formatDate(date) {
        if (!date) return ''
        return this.$moment(date).format('ddd DD-MM-YY')
      },
      formatBluetooth(bluetoothId) {
        if (!bluetoothId) return ''
        if (bluetoothId.length != 17) return bluetoothId
        return 'iMatch-' + bluetoothId.substring(12, 14) + bluetoothId.substring(15,17)
      },
      getStateValue(key) {
        return this.states.find(x => x.key == key).value
      },
      getData() {
        this.assemblies = []
        this.selectedAssembly = null
        this.$http.get('api/assembly/' + this.typeFilterQuery)
          .then(request => {
            if (request.status == 200 && Array.isArray(request.data)) {
              request.data.forEach(x => {
                x.bluetoothId = this.formatBluetooth(x.bluetoothId)
              })
              this.assemblies = request.data
            }
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */
      },
      editAssembly(id)  {
        this.selectedAssembly = this.assemblies.find(x => x.id == id)
      },
      getAssemblyTypes() {
        this.$http
          .get("api/assembly/types")
          .then(request => {
            this.assemblyTypes = request.data;
          })
          .catch(e => {
              console.log('get error!', e) /* eslint-disable-line no-console */
              this.submitStatus = 'ERROR'
          });
      },
      getAssemblyTypeNameById(id) {
        if (this.assemblyTypes.length) {
          return this.assemblyTypes.find(x => x.id == id).name;
        }
        return '';
      }
    },
    mounted() {
      this.getAssemblyTypes()
      this.getData()
    }
  }
</script>
